import React, { useState } from 'react';
import { Download, FileText, FileSpreadsheet, Code2, FileIcon, Loader2 } from 'lucide-react';
import { claudeQueryService } from '../../../../../services/claudeQueryService';

interface FileBlockData {
    filename: string;
    mimeType: string;
    sizeBytes: number;
    downloadUrl: string;
    fileId: string;
}

interface FileBlockProps {
    data: FileBlockData;
}

function formatFileSize(bytes: number): string {
    if (bytes < 1024) return `${bytes} B`;
    if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

function getFileIcon(mimeType: string) {
    if (mimeType.includes('csv') || mimeType.includes('text')) return <FileText size={20} className="text-green-600" />;
    if (mimeType.includes('spreadsheet') || mimeType.includes('excel')) return <FileSpreadsheet size={20} className="text-green-700" />;
    if (mimeType.includes('json') || mimeType.includes('html')) return <Code2 size={20} className="text-blue-600" />;
    return <FileIcon size={20} className="text-gray-500" />;
}

export const FileBlock: React.FC<FileBlockProps> = ({ data }) => {
    const [downloading, setDownloading] = useState(false);

    const handleDownload = async () => {
        setDownloading(true);
        try {
            const { blob, filename } = await claudeQueryService.downloadExportFile(data.fileId);
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error('Download failed:', error);
        } finally {
            setDownloading(false);
        }
    };

    return (
        <div className="mt-2 flex items-center gap-3 p-3 bg-gray-50 border border-gray-200 rounded-lg">
            {getFileIcon(data.mimeType)}
            <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-800 truncate">{data.filename}</p>
                <p className="text-xs text-gray-500">{formatFileSize(data.sizeBytes)}</p>
            </div>
            <button
                onClick={handleDownload}
                disabled={downloading}
                className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-medium text-blue-700 bg-blue-50 hover:bg-blue-100 rounded-md transition-colors disabled:opacity-50"
            >
                {downloading ? (
                    <Loader2 size={14} className="animate-spin" />
                ) : (
                    <Download size={14} />
                )}
                Last ned
            </button>
        </div>
    );
};
